import { SET_DECEASED_DETAILS } from './DeceasedDetailsActions';

export const setDeceasedDetailsReducer = (state={}, action) => {
  const { type, field, value, isAddress } = action;
  switch (type){
  case SET_DECEASED_DETAILS :{
    if (isAddress){
      if( field === 'dAddressMilitary'){
        const { dAddress } = state;
        const newAddress = {
          ...dAddress,
          ['dAddressCity']:'',
          [field]: value
        }
        return {
          ...state,
          dAddress: newAddress
        }
      }
      const { dAddress } = state;
      const newAddress = {
        ...dAddress,
        [field]: value
      }
      return {
        ...state,
        dAddress: newAddress
      }
    }
    return { ...state,
      [field]: value }
  }
  default:{
    return state
  }
  }
}